import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DistrictsList.css';

const TrashedFormsList = () => {
  const [trashedForms, setTrashedForms] = useState([]);
  const [trashedInstances, setTrashedInstances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restoreConfirm, setRestoreConfirm] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchTrashedItems();
  }, []);

  const fetchTrashedItems = async () => {
    try {
      console.log('Fetching trashed items...');
      const [formsResponse, instancesResponse] = await Promise.all([
        axios.get('/api/form-submissions/trashed-forms'),
        axios.get('/api/form-instances/trashed')
      ]);

      console.log('Forms response:', formsResponse.data);
      console.log('Instances response:', instancesResponse.data);

      setTrashedForms(formsResponse.data);
      setTrashedInstances(instancesResponse.data);
    } catch (error) {
      console.error('Failed to fetch trashed items:', error);
      console.error('Error details:', error.response?.data || error.message);
      // Show error to user
      alert(`Failed to load trashed items: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (item, type) => {
    try {
      if (type === 'form') {
        await axios.post(`/api/form-submissions/restore-form/${item.id}`);
        setTrashedForms(trashedForms.filter(form => form.id !== item.id));
      } else {
        await axios.post(`/api/form-instances/restore/${item.id}`);
        setTrashedInstances(trashedInstances.filter(instance => instance.id !== item.id));
      }
      setRestoreConfirm(null);
      alert(`${type === 'form' ? 'Form' : 'Form instance'} restored successfully`);
    } catch (error) {
      console.error('Failed to restore item:', error);
      alert('Failed to restore item');
    }
  };

  const handlePermanentDelete = async (item, type) => {
    try {
      if (type === 'form') {
        await axios.delete(`/api/form-submissions/permanent-delete/${item.id}`);
        setTrashedForms(trashedForms.filter(form => form.id !== item.id));
      } else {
        await axios.delete(`/api/form-instances/permanent/${item.id}`);
        setTrashedInstances(trashedInstances.filter(instance => instance.id !== item.id));
      }
      setDeleteConfirm(null);
      alert(`${type === 'form' ? 'Form' : 'Form instance'} permanently deleted`);
    } catch (error) {
      console.error('Failed to permanently delete item:', error);
      alert('Failed to permanently delete item');
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>Trashed Forms</h2>
        <p>Forms that have been soft-deleted. They will be permanently deleted after 7 days.</p>
      </div>

      {restoreConfirm && (
        <div className="modal-overlay" onClick={() => setRestoreConfirm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Restore {restoreConfirm.type === 'form' ? 'Form' : 'Form Instance'}</h3>
            <p>Are you sure you want to restore this {restoreConfirm.type === 'form' ? 'form' : 'form instance'}? {restoreConfirm.type === 'form' ? 'It will be available to parents again.' : 'It will be available for assignment to districts again.'}</p>
            <div className="modal-actions">
              <button onClick={() => handleRestore(restoreConfirm.item, restoreConfirm.type)} className="btn-primary">Restore</button>
              <button onClick={() => setRestoreConfirm(null)} className="btn-secondary">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Permanently Delete {deleteConfirm.type === 'form' ? 'Form' : 'Form Instance'}</h3>
            <p><strong>Warning:</strong> This action cannot be undone. The {deleteConfirm.type === 'form' ? 'form' : 'form instance'} will be permanently deleted from the database.</p>
            <div className="modal-actions">
              <button onClick={() => handlePermanentDelete(deleteConfirm.item, deleteConfirm.type)} className="btn-danger">Permanently Delete</button>
              <button onClick={() => setDeleteConfirm(null)} className="btn-secondary">Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ marginBottom: '2rem' }}>
        <h3>Trashed Submitted Forms</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Student Name</th>
              <th>Form Type</th>
              <th>Instance Name</th>
              <th>District</th>
              <th>Parent</th>
              <th>Deleted Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {trashedForms.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>No trashed submitted forms found</td>
              </tr>
            ) : (
              trashedForms.map(form => (
                <tr key={form.id}>
                  <td><strong>{form.student_first_name} {form.student_last_name}</strong></td>
                  <td>{form.master_form_name}</td>
                  <td>{form.instance_name}</td>
                  <td>{form.district_name}</td>
                  <td>{form.parent_first_name} {form.parent_last_name}</td>
                  <td>{new Date(form.deleted_at).toLocaleDateString()}</td>
                  <td className="actions">
                    <button onClick={() => setRestoreConfirm({ item: form, type: 'form' })} className="btn-primary">Restore</button>
                    <button onClick={() => setDeleteConfirm({ item: form, type: 'form' })} className="btn-danger">Delete Forever</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div>
        <h3>Trashed Form Instances</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Instance Name</th>
              <th>Master Form</th>
              <th>Assigned Districts</th>
              <th>Created Date</th>
              <th>Deleted Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {trashedInstances.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>No trashed form instances found</td>
              </tr>
            ) : (
              trashedInstances.map(instance => (
                <tr key={instance.id}>
                  <td><strong>{instance.instance_name}</strong></td>
                  <td>{instance.master_form_name}</td>
                  <td>
                    {instance.assigned_districts && instance.assigned_districts.length > 0 ? (
                      <div>
                        {instance.assigned_districts.map((district, index) => (
                          <div key={index} style={{ marginBottom: '2px' }}>
                            {district.district_name}
                            {district.is_required && <span style={{ color: '#e74c3c', marginLeft: '5px' }}>(Required)</span>}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <span style={{ color: '#7f8c8d' }}>No assignments</span>
                    )}
                  </td>
                  <td>{new Date(instance.created_at).toLocaleDateString()}</td>
                  <td>{new Date(instance.deleted_at).toLocaleDateString()}</td>
                  <td className="actions">
                    <button onClick={() => setRestoreConfirm({ item: instance, type: 'instance' })} className="btn-primary">Restore</button>
                    <button onClick={() => setDeleteConfirm({ item: instance, type: 'instance' })} className="btn-danger">Delete Forever</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TrashedFormsList;
